
import { useState, useEffect } from 'react';
import GlitchText from '../base/GlitchText';

interface NavigationProps {
  activeSection?: string;
  onSectionChange?: (section: string) => void;
}

export default function Navigation({ activeSection, onSectionChange }: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: 'SYSTEM', icon: 'ri-computer-line' },
    { id: 'about', label: 'CPU', icon: 'ri-cpu-line' },
    { id: 'skills', label: 'GPU', icon: 'ri-dashboard-line' },
    { id: 'portfolio', label: 'STORAGE', icon: 'ri-hard-drive-line' },
    { id: 'projects', label: 'MEMORY', icon: 'ri-database-line' },
    { id: 'experience', label: 'NETWORK', icon: 'ri-wifi-line' },
    { id: 'contact', label: 'POWER', icon: 'ri-flashlight-line' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      onSectionChange?.(sectionId);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/90 backdrop-blur-md border-b border-cyan-500/30' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/9be9028b55203ebd765bf33851a55a8d/11750a71246d9a99155fff4c34b15a99.jpeg"
              alt="Aditya Prakash"
              className="w-10 h-10 rounded-full border-2 border-cyan-400 shadow-lg shadow-cyan-400/50"
            />
            <div>
              <h1 className="text-xl font-bold text-white font-orbitron">
                <GlitchText text="ADITYA.SYS" />
              </h1>
              <div className="text-xs text-cyan-400 font-mono">v2.0.24 ONLINE</div>
            </div>
          </div>

          {/* Navigation Menu */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`
                  px-4 py-2 rounded-md font-mono text-sm transition-all duration-300
                  flex items-center space-x-2 group
                  ${activeSection === item.id 
                    ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/50' 
                    : 'text-gray-300 hover:text-cyan-400 hover:bg-cyan-500/10'
                  }
                `}
              >
                <i className={`${item.icon} text-sm group-hover:animate-pulse`}></i>
                <span>{item.label}</span>
              </button>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-cyan-400 text-xl">
            <i className="ri-menu-line"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
